import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Flex, Text, Transition } from '@mantine/core';
import { getPrimaryColor } from '../column.utils';
export const MRT_ToolbarDropZone = ({ table, }) => {
    const { getState, options: { enableGrouping, localization }, setHoveredColumn, setShowToolbarDropZone, } = table;
    const { draggingColumn, hoveredColumn, grouping, showToolbarDropZone } = getState();
    const handleDragEnter = (_event) => {
        setHoveredColumn({ id: 'drop-zone' });
    };
    useEffect(() => {
        var _a;
        if (((_a = table.options.state) === null || _a === void 0 ? void 0 : _a.showToolbarDropZone) !== undefined) {
            setShowToolbarDropZone(!!enableGrouping &&
                !!draggingColumn &&
                draggingColumn.columnDef.enableGrouping !== false &&
                !grouping.includes(draggingColumn.id));
        }
    }, [enableGrouping, draggingColumn, grouping]);
    return (_jsx(Transition, { mounted: showToolbarDropZone, transition: "fade", children: (styles) => {
            var _a, _b;
            return (_jsx(Flex, { className: "mantine-ToolbarDropZone", sx: (theme) => ({
                    alignItems: 'center',
                    backgroundColor: theme.fn.rgba(getPrimaryColor(theme), (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === 'drop-zone' ? 0.2 : 0.1),
                    border: `dashed ${getPrimaryColor(theme)} 2px`,
                    justifyContent: 'center',
                    height: 'calc(100%)',
                    position: 'absolute',
                    width: 'calc(100%)',
                    zIndex: 2,
                }), onDragEnter: handleDragEnter, style: styles, children: _jsx(Text, { children: localization.dropToGroupBy.replace('{column}', (_b = (_a = draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.columnDef) === null || _a === void 0 ? void 0 : _a.header) !== null && _b !== void 0 ? _b : '') }) }));
        } }));
};
//# sourceMappingURL=MRT_ToolbarDropZone.js.map